
<div class="pt-2 pb-3">
  <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
    <form [formGroup]="billboardVdEditForm">

      <div class="d-flex flex-row">
        <div class="pe-2 flex-grow-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.name' | translate}}</mat-label>
            <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}" data-nar="billboardvideo-widget-name">
          </mat-form-field>
        </div>
        <div class="ps-2 flex-grow-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{'pass.subtitle' | translate}}</mat-label>
            <input formControlName="subtitle" type="text" matInput placeholder="{{'pass.subtitle' | translate}}" data-nar="billboardvideo-widget-subtitle">
          </mat-form-field>
        </div>
      </div>

      <mat-card class="mb-4">
        <mat-card-content>
          <div class="p-2">
            @if (url || urlData) {
              <div >
                <div class="d-flex align-items-center mb-3">
                  <mat-icon class="material-symbols-outlined">subscriptions</mat-icon>
                  <span class="px-2">{{'pass.widgets.video' | translate}}</span>
                </div>
                <div class="d-flex justify-content-stretch flex-column">
                  @if (!url) {
                    <video crossorigin="anonymous" [vgMedia]="$any(media)" #media id="singleVideoBV" preload="auto" controls width="100%"  class="me-2" style="max-height:300px;" (loadedmetadata)="onVideoMetadataBillVideo($event)">
                      <source [src]="urlData" type="video/mp4" >
                    </video>
                  }
                  @if (url && urlData) {
                    <video crossorigin="anonymous" [vgMedia]="$any(media)" #media id="singleVideoBV" preload="auto" controls width="100%"  class="me-2" style="max-height:300px;" (loadedmetadata)="onVideoMetadataBillVideo($event)">
                      <source [src]="urlData" type="video/mp4" >
                    </video>
                  }
                  @if (url && !urlData) {
                    <video crossorigin="anonymous" [vgMedia]="$any(media)" #media id="singleVideoBV" preload="auto" controls width="100%" class="me-2" style="max-height:300px;" (loadedmetadata)="onVideoMetadataBillVideo($event)">
                      <source [src]="url" type="video/mp4" >
                    </video>
                  }
                  <div class="form-fields mt-4">
                    <div class="d-flex align-items-start">
                      <mat-form-field appearance="outline" class="flex-grow-1">
                        <mat-icon matIconPrefix class="material-symbols-outlined">link</mat-icon>
                        <mat-label>{{ 'pass.url' | translate }}</mat-label>
                        @if (url) {
                          <input type="text" formControlName="url" matInput (change)="checkNewUrl()" >
                        }
                        @if (!url) {
                          <input type="text" formControlName="url" matInput (change)="checkNewUrl()" data-nar="billboardvideo-widget-video-source">
                        }
                        @if (billboardVdEditForm.controls['url']?.hasError('invalidCharacters')) {
                          <mat-error>
                            {{ 'invalid_characters' | translate }}
                          </mat-error>
                        }
                        @if (billboardVdEditForm.controls['url']?.hasError('pattern') && !billboardVdEditForm.controls['url']?.hasError('invalidCharacters')) {
                          <mat-error>
                            {{ 'url_pattern_invalid' | translate }}
                          </mat-error>
                        }
                        <button mat-icon-button matSuffix (click)="deleteVideo()" class="delete-button" matTooltip="{{ 'pass.deleteVideo' | translate }}" [disabled]="translationModeOriginal">
                          <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                  </div>
                  <mat-form-field appearance="outline" class="flex-grow-1">
                    <mat-label>{{ 'pass.altTitle' | translate }}</mat-label>
                    <input type="text" formControlName="altTitle" matInput data-nar="billboardvideo-widget-alt">
                  </mat-form-field>
                </div>
                @if (userHasBetaWidgetRole) {
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title style="color:#595c5f;">
                        <mat-icon style="margin-right: 10px;">image</mat-icon> {{'pass.videoThumbnail' | translate}}
                        <span class="badge custom-badge rounded-pill ms-2">Beta</span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <canvas #canvasElement style="display:none;"></canvas>
                    @if (thumbnailUrl) {
                      <div> <img [src]="thumbnailUrl" style="width: 100%; margin-top: 10px;" /> </div>
                    }
                    <button mat-button matTooltip="{{'pass.video.captureFrameHint' | translate}}" (click)="updateFrame()" class="secondary-gray-button my-3" [disabled]="translationModeOriginal || data.translateMode">
                      <mat-icon class="material-symbols-outlined">capture</mat-icon> {{'pass.video.captureFrame' | translate}}
                    </button>
                  </mat-expansion-panel>
                }
              </div>
            }
            @if (!hasAnyVideo && !dynamicUrl) {
              <div>
                <div class="d-flex align-items-center mb-3">
                  <mat-icon class="material-symbols-outlined">subscriptions</mat-icon>
                  <span class="px-2">{{'pass.widgets.video' | translate}}</span>
                </div>
                <div [app-drag-file-browse-ui]="dragFileData" (returnChanges)="returnChangesDragFileBrowseUI($event)"></div>
              </div>
            }
          </div>
        </mat-card-content>
      </mat-card>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'pass.copyright' | translate}}</mat-label>
        <input formControlName="copyright" type="text" matInput placeholder="{{'pass.copyright' | translate}}" data-nar="billboardvideo-widget-copyright">
      </mat-form-field>

      @for (config of videoConfigurations; track config) {
        <div class="form-control p-3 mb-3 d-flex justify-content-between w-100">
          <div class="d-flex align-items-center">
            <span class="material-symbols-outlined me-2">{{config.icon}}</span>
            <label>{{config.translation | translate}}</label>
          </div>
          <mat-slide-toggle class="ms-5 example-margin" formControlName="{{config.controlName}}"></mat-slide-toggle>
        </div>
      }

    </form>
  </section>
  <div [app-widget-edit-filters] = "{'form':billboardVdEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesFilters($event)"></div>
</div>